import { NetworkError } from "../ApiErrors.js";
const getDelay = (baseDelay, attempts) => {
    // Exponential backoff with jitter
    return baseDelay * Math.pow(2, attempts) * (0.5 + Math.random() * 0.5);
};
/**
 * Retry a fetch request
 * @param fn - The fetch function to retry
 * @param options - [optional] The options for the retry
 * @param options.maxRetries - The maximum number of retries
 * @param options.baseDelay - The base delay in milliseconds
 * @param options.attempts - The number of attempts to retry
 * @returns The response from the fetch
 */
export async function retry(fn, options) {
    const RETRYABLE_STATUS_CODES = [408, 429, 500, 502, 503, 504];
    const { maxRetries = 1, baseDelay = 1000, attempts = 0 } = options || {};
    try {
        const response = await fn();
        if (!RETRYABLE_STATUS_CODES.includes(response.status) ||
            attempts >= maxRetries) {
            return response;
        }
        const delay = getDelay(baseDelay, attempts);
        await new Promise((resolve) => setTimeout(resolve, delay));
        return retry(fn, {
            ...options,
            attempts: attempts + 1,
        });
    }
    catch (error) {
        // Retry on NetworkError
        if (error instanceof NetworkError && attempts < maxRetries) {
            const delay = getDelay(baseDelay, attempts);
            await new Promise((resolve) => setTimeout(resolve, delay));
            return retry(fn, {
                ...options,
                attempts: attempts + 1,
            });
        }
        // Re-throw the error if it's not a NetworkError or we've exceeded max retries
        throw error;
    }
}
